import React, { createContext, useContext, useState } from "react";

const ReturnContext = createContext({
  returnData: [],
  setReturnData: () => { },
  clearReturnData: () => { },
});

export const useReturnItemData = () => useContext(ReturnContext);

export const ReturnContextProvider = ({ children }) => {
  const [returnData, setReturnData] = useState([]);

  const clearReturnData = () => {
    setReturnData([]);
  };


  return (
    <ReturnContext.Provider value={{ returnData, setReturnData, clearReturnData }}>
      {children}
    </ReturnContext.Provider>
  );
};
